export default __webpack_public_path__ + "static/media/ImpactSoftLogo.0975d0f2.png";